import { Alert, Table } from "flowbite-react";
import TitleStripe from "../TitleStripe";
import NoOcurrence from "./NoOcurrence";
import { formatToReal } from "../../../utils/utils";

const CadastralPJ = ({ data }) => {
  return (
    <>
      <TitleStripe>Dados cadastrais</TitleStripe>
      {data?.statusRetorno == 1 ? (
        <>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
            <div className="flex items-center gap-2">
              <div className="font-semibold">Razão Social:</div>
              <div className="capitalize">
                {data?.razaoSocial?.toLowerCase()}
              </div>
            </div>
            <div className="flex items-center gap-2">
              <div className="font-semibold">Status:</div>
              <div>{data?.situacao}</div>
            </div>
            <div className="flex items-center gap-2">
              <div className="font-semibold">Data de fundação:</div>
              <div>{data?.dataFundacao}</div>
            </div>
            <div className="flex items-center gap-2">
              <div className="font-semibold">Natureza Jurídica:</div>
              <div>{data?.naturezaJuridica?.toLowerCase()}</div>
            </div>
            <div className="flex items-center gap-2">
              <div className="font-semibold">Capital Social:</div>
              <div>{formatToReal(data?.capitalInicial)}</div>
            </div>
          </div>
          <div>
            <div className="flex gap-2 -mt-1">
              <div className="font-semibold whitespace-nowrap">
                Ativ. primária:
              </div>
              <div className="capitalize">
                {data?.ramoAtividade?.toLowerCase()}
              </div>
            </div>
          </div>

          <TitleStripe>Histórico de endereço</TitleStripe>
          {data?.enderecos?.length > 0 ? (
            <div className="overflow-hidden rounded-md">
              <Table striped className="w-full">
                <Table.Head>
                  <td className="bg-primary py-1 px-1 font-semibold text-2xs text-white">
                    Endereço
                  </td>
                  <td className="bg-primary py-1 px-1 text-center font-semibold text-2xs text-white">
                    Bairro
                  </td>
                  <td className="bg-primary py-1 px-1 text-center font-semibold text-2xs text-white">
                    Cidade
                  </td>
                  <td className="bg-primary py-1 px-1 text-center font-semibold text-2xs text-white">
                    CEP
                  </td>
                </Table.Head>
                <Table.Body>
                  {data?.enderecos?.map((address, index) => (
                    <tr
                      key={index}
                      className={`${
                        index % 2 !== 0 ? "bg-white" : "bg-gray-100"
                      }`}
                    >
                      <td className="p-1">
                        {address.endereco}, {address.numero}
                      </td>
                      <td className="p-1 text-center">{address.bairro}</td>
                      <td className="p-1 text-center">{address.cidade}</td>
                      <td className="p-1 text-center">{address.cep}</td>
                    </tr>
                  ))}
                </Table.Body>
              </Table>
            </div>
          ) : (
            <NoOcurrence />
          )}

          <TitleStripe>Histórico de email</TitleStripe>
          {data?.emails?.length > 0 ? (
            <div className="overflow-hidden rounded-md">
              <Table striped className="w-full">
                <Table.Head>
                  <td className="bg-primary py-1 px-1 font-semibold text-2xs text-white">
                    Email
                  </td>
                </Table.Head>
                <Table.Body>
                  {data?.emails?.map((email, index) => (
                    <tr
                      key={index}
                      className={`${
                        index % 2 !== 0 ? "bg-white" : "bg-gray-100"
                      }`}
                    >
                      <td className="p-1">{email}</td>
                    </tr>
                  ))}
                </Table.Body>
              </Table>
            </div>
          ) : (
            <NoOcurrence />
          )}

          <TitleStripe>Histórico de telefones</TitleStripe>
          {data?.telefones?.length > 0 ? (
            <div className="overflow-hidden rounded-md">
              <Table striped className="w-full">
                <Table.Head>
                  <td className="bg-primary py-1 px-1 font-semibold text-2xs text-white text-center">
                    DDD
                  </td>
                  <td className="bg-primary py-1 px-1 font-semibold text-2xs text-white text-center">
                    Número
                  </td>
                </Table.Head>
                <Table.Body>
                  {data?.telefones?.map((number, index) => (
                    <tr
                      key={index}
                      className={`${
                        index % 2 !== 0 ? "bg-white" : "bg-gray-100"
                      }`}
                    >
                      <td className="p-1 text-center">{number.ddd}</td>
                      <td className="p-1 text-center">{number.numero}</td>
                    </tr>
                  ))}
                </Table.Body>
              </Table>
            </div>
          ) : (
            <NoOcurrence />
          )}

          <TitleStripe>Histórico de celulares</TitleStripe>
          {data?.celulares?.length > 0 ? (
            <div className="overflow-hidden rounded-md">
              <Table striped className="w-full">
                <Table.Head>
                  <td className="bg-primary py-1 px-1 font-semibold text-2xs text-white text-center">
                    DDD
                  </td>
                  <td className="bg-primary py-1 px-1 font-semibold text-2xs text-white text-center">
                    Número
                  </td>
                </Table.Head>
                <Table.Body>
                  {data?.celulares?.map((number, index) => (
                    <tr
                      key={index}
                      className={`${
                        index % 2 !== 0 ? "bg-white" : "bg-gray-100"
                      }`}
                    >
                      <td className="p-1 text-center">{number.ddd}</td>
                      <td className="p-1 text-center">{number.numero}</td>
                    </tr>
                  ))}
                </Table.Body>
              </Table>
            </div>
          ) : (
            <NoOcurrence />
          )}

          <TitleStripe>Quadro Societário</TitleStripe>
          {data?.socios?.length > 0 ? (
            <div className="overflow-hidden rounded-md">
              <Table striped className="w-full">
                <Table.Head>
                  <td className="bg-primary py-1 px-1 font-semibold text-2xs text-white">
                    CPF
                  </td>
                  <td className="bg-primary py-1 px-1 font-semibold text-2xs text-white">
                    Nome
                  </td>
                  <td className="bg-primary py-1 px-1 font-semibold text-2xs text-white text-center">
                    Cargo
                  </td>
                </Table.Head>
                <Table.Body>
                  {data?.socios.map((part, index) => (
                    <tr
                      key={index}
                      className={`${
                        index % 2 !== 0 ? "bg-white" : "bg-gray-100"
                      }`}
                    >
                      <td className="p-1">{part.documento}</td>
                      <td className="p-1">{part.nome_rf}</td>
                      <td className="p-1 text-center">{part.cargo}</td>
                    </tr>
                  ))}
                </Table.Body>
              </Table>
            </div>
          ) : (
            <NoOcurrence />
          )}
        </>
      ) : (
        <Alert className="mt-2" color="gray" withBorderAccent>
          Consulta indisponível no momento!
        </Alert>
      )}
    </>
  );
};

export default CadastralPJ;
